<template>
  <div style="padding-top:44px;">
    <h3 class="title">助手</h3>
    <div class="order-list tt-custom-tab" style="padding:0 65px 0 30px;">
      <div class="search-bar" style="justify-content:flex-start;">
        <div>
          <el-select style="width:100%;" v-model="form.type_of"
            class="input-width" placeholder="来源" @change="search">
            <el-option v-for="item in sources" :key="item.type_of" :label="item.type_of_cn" :value="item.type_of"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:100%;"
                v-model="form.merchant_tag"
                clearable
                filterable
                :filter-method="filterSearch"
                class="input-width"
                @change="handleAutoSelect"
                @clear="handleClear"
                placeholder="商家">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"></el-option>
              </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:110px;" v-model="form.status"
            class="input-width" placeholder="状态" @change="search">
            <el-option v-for="item in crawlerstatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <div style="display: flex;align-items: center;">
            <div class="combo-left preix-select">
              <label class="el-input__inner">发帖时间</label>
            </div>
            <span class="combo-right">
              <el-date-picker format="yyyy-MM-dd HH:mm" @change="search" v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
                end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </span>
          </div>
        </div>
        <div style="margin-left:20px;">
          <el-button type="primary" @click="refresh">刷 新</el-button>
        </div>
      </div>
      <!--<div class="search-bar seprator">
        <div style="display:flex;align-items:center;">
          <span>
              {{totalCount}}个邮件&nbsp;&nbsp;
          </span>
        </div>    
      </div>-->
      <div v-if="loading" class="table" style="display: flex;justify-content: center;">
        <Loading></Loading>
      </div>
      <div v-if="!loading && totalCount>0" class="table">
        <div class="table-head" style="border-bottom:1px solid #f3f3f9">
          <div v-for="c in columns" :style="{width:c.width}">
            {{ c.name }}
          </div>
        </div>
        <div>
            <div v-for="(r,index) in list" :key="index">
              <div class="article-row" :class="{'email':r.type_of=='email'}" @click="showContent(r)">
                <template v-if="r.type_of!='email'">
                  <div style="width:150px">
                      <p style="font-size: 16px; padding-bottom: 5px;">{{ generateDateDisplay(r.posting_time) }}</p>
                      <p style="color: rgb(102, 102, 102);">{{ r.posting_time | moment('HH:mm:ss') }}</p>
                  </div>
                  <div style="width:calc(100% - 300px)">
                      <p style="padding-bottom: 5px;display: flex;align-items: center;">
                        <img v-if="r.joyorders_merchant_country" :src="`https://pic.joyorders.com/country//${r.joyorders_merchant_country.toLowerCase()}.png`" style="width:28px;height:16px;margin-right:10px;object-fit: contain;"/>
                        <label v-if="r.joyorders_merchant_country" style="font-size:16px;margin-right:15px;">{{ r.joyorders_merchant_name }}</label>
                        <label v-if="r.enable_to_convert" style="font-size:16px;color:inherit;text-decoration: underline;cursor: pointer;" target="_blank" :href="r.url" @click.stop="navToPost(r)">
                          {{ r.title }}
                        </label>
                        <label v-else style="font-size:16px;color:inherit;">
                          {{ r.title }}
                        </label>
                      </p>
                      <p style="color: rgb(102, 102, 102);">
                        <a style="color:inherit;margin-right: 8px;" target="_blank" :href="r.url">
                          <i class="el-icon-link" style="font-size: 16px;margin-right: 2px;"></i>{{ r.type_of_cn+' ' }}
                        </a>
                        {{ generateDateDisplay(r.create_time)+' '}}{{ r.create_time | moment('HH:mm:ss') }}
                      </p>
                    </div>
                    <div style="width:150px">
                      <el-dropdown trigger="click" style="width:96px;" @command="handleCommand($event,r)">
                        <template v-if="r.status==0">
                          <el-button v-loading="r.updating" style="width:96px;" class="block btn-14 nohover" type="info">
                            {{ getStatus(+r.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                        </template>
                        <template v-else>
                          <el-button v-loading="r.updating" style="width:96px;" class="block btn-14 nohover">
                            {{ getStatus(+r.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                        </template>
                        <el-dropdown-menu class="operationStatus crawlerStatus" slot="dropdown">
                          <el-dropdown-item :command="item.id" v-for="(item,index) in crawlerop" :key="item.id">{{ item.name }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                </template>
                <template v-else>
                  <div style="width:150px">
                      <p style="font-size: 16px; padding-bottom: 5px;">{{ generateDateDisplay(r.posting_time) }}</p>
                      <p style="color: rgb(102, 102, 102);">{{ r.posting_time | moment('HH:mm:ss') }}</p>
                  </div>
                  <div style="width:calc(100% - 300px)">
                      <p style="padding-bottom: 5px;display: flex;align-items: center;">
                        <img v-if="r.joyorders_merchant_country" :src="`https://pic.joyorders.com/country//${r.joyorders_merchant_country.toLowerCase()}.png`" style="width:28px;height:16px;margin-right:10px;object-fit: contain;"/>
                        <label v-if="r.joyorders_merchant_country" style="font-size:16px;margin-right:15px;">{{ r.joyorders_merchant_name }}</label>
                        <label v-if="r.enable_to_convert" style="font-size:16px;color:inherit;text-decoration: underline;cursor: pointer;" target="_blank" @click.stop="navToPost(r)">
                          {{ r.title }}
                        </label>
                        <label v-else style="font-size:16px;color:inherit;">
                          {{ r.title }}
                        </label>
                      </p>
                      <p style="color: rgb(102, 102, 102);">
                        <a style="color:inherit;margin-right: 8px;" href="javascript:void(0)">
                          <i class="el-icon-message" style="font-size: 16px;margin-right: 2px;position:relative;top:1px;"></i>{{ r.email+' ' }}
                        </a>
                        {{ generateDateDisplay(r.create_time)+' '}}{{ r.create_time | moment('HH:mm:ss') }}
                      </p>
                    </div>
                    <div style="width:150px">
                      <el-dropdown trigger="click" style="width:96px;" @command="handleCommand($event,r)">
                        <template v-if="r.status==0">
                          <el-button v-loading="r.updating" style="width:96px;" class="block btn-14 nohover" type="info">
                            {{ getStatus(+r.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                        </template>
                        <template v-else>
                          <el-button v-loading="r.updating" style="width:96px;" class="block btn-14 nohover">
                            {{ getStatus(+r.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                        </template>
                        <el-dropdown-menu class="operationStatus crawlerStatus" slot="dropdown">
                          <el-dropdown-item :command="item.id" v-for="(item,index) in crawlerop" :key="item.id">{{ item.name }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                </template>
              </div>
              <div v-if="r.showContent">
                <iframe :id="`myIframe${r.id}`" loading="lazy"
                        width="100%"
                        height="600px"
                        :srcdoc="r.content_info">
                </iframe>
              </div>
            </div>
        </div>
      </div>
      <div class="order-list" v-if="!loading && totalCount==0" style="margin-top:80px;text-align: center;">
        <div class="empty-logo">
            <div class="rhombus-narrow"></div>
            <div class="rhombus-narrow left">
              <div class="border"></div>
            </div>
            <div class="rhombus-narrow right">
              <div class="border"></div>
            </div>
          </div>
          <h4>没有相关帖子</h4>
        </div>
        <div class="yd-pagination" v-if="totalCount / form.limit > 1">
          <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
            next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
          </el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import Loading from '../../components/Loading'
let _ = require('lodash')

export default {
  name: 'ArticleCrawler',
  data() {
    return {
      loading:true,
      account_id:this.$localStorage.get('account_id'),
      activeName: '0',
      list: [],
      timeRange: [],
      merchants: [],
      merchantOptions:[],
      totalBussnies:[],
      crawlerstatus:[
        { id:'-1',name:'全部' },
        { id:'0',name:'待处理' },
        { id:'1',name:'已处理' },
        { id:'2',name:'已忽略' },
      ],
      crawlerop:[
        { id:'1',name:'已处理' },
        { id:'2',name:'已忽略' },
        { id:'0',name:'待处理' },
      ],
      columns: [
        { name: '发帖时间', field: 'post_time',width:'150px' },
        { name: '帖子信息', field: 'title',width:'calc(100% - 300px)' },
        { name: '操作', field: 'title',width:'150px' },
      ],
      searchWord: '',
      sources: [],
      form:{
        limit:30,
        page:1,
        type_of:'',
        status:'-1',
        posting_time_from:'',
        posting_time_to:''
      },
      totalCount:0,
    }
  },
  components: {
    Loading: Loading
  },
  async mounted() {
    this.getGroupBussinessList();
    this.getSources();
    if(localStorage.getItem('articleList_timeRange'))
      this.timeRange=JSON.parse(localStorage.getItem('articleList_timeRange'))
    else{
      let y = new Date().getFullYear();
      let end = new Date(y,11,31,23,59,59)
      this.timeRange=[new Date(end.getTime()-365*24*3600*1000+1000),end]
    }
    this.search()
  },
  /*watch: {
            r(val) {
                if (val.type_of != 'email') {
                    return
                }
                let id = 'myIframe' + val.id
                const iframe = document.getElementById(id);
                if (iframe) {
                    const iframeDoc = iframe.contentDocument
                    if (!iframeDoc) {
                        return
                    }
                    iframeDoc.addEventListener('click', function (e) {
                        let url = e.target.src;
                        if (url) {
                            let p = e.target.closest('[href]');
                            if (p) {
                                url = p.href
                            }
                        } else {
                            url = e.target.href;
                        }
                        if (url) {
                            // 在父页面控制新窗口打开
                            window.open(url, '_blank');
                            e.preventDefault(); // 阻止默认行为
                        }
                    });
                }
            },

        },*/
  methods: {
    async showContent(r){
      if(r.type_of=='email'){
        if(r.showContent){
          r.showContent=false;
          this.$forceUpdate();
          return;
        }
        else{
          if(!r.content_info){
            let temp=  await api.getMailContent(this,{mail_id:r.mail_id});
            let content = temp.body.result
            r.content_info=content.content_info;
            r.showContent=true;
            this.$forceUpdate();
          }
        }
      }
    },
    navToPost(r){
      if(r.joyorders_post_id && r.joyorders_post_id!='0'){
         window.open('/explore/post?id='+r.joyorders_post_id,'blank');
      }
      else
        window.open('/publish?convert='+r.id,'blank');
    },
    getStatus(status){
      switch(status){
        case 0:
          return '待处理';
        case 1:
          return '已处理';
        case 2:
          return '已取消';
      }
    },
    async handleCommand(e,item){
      console.log('event',e,item);
      let data = {
        id:item.id,
        status:e
      }
      item.updating = true;
      let res = await api.post(this, {
        path: 'spider.php',
        api: 'update_status',
        data:data
      })
      item.updating = false;
      res = res.body
      if (res.status == 'ok') {
        item.status = e;
        this.$forceUpdate()
      }
    },
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.totalBussnies=result;
      console.log('test',this.totalBussnies);
    },
    handleClear(){
      this.merchantOptions = []
      this.totalBussnies.forEach(item => {
        this.merchantOptions.push({value:item.merchant_name,id:item.merchant_tag})
      })
    },
    refresh(){
      this.form.page = 1;
      this.search();
    },
    handleAutoSelect(item){
      this.searchMerchant=item;
      this.form.page = 1;
      this.search();
    },
    filterSearch(val){
      this.merchantOptions = []
      let mers=[];
      if(val){
        setTimeout(()=>{
          mers=this.totalBussnies.filter((item)=>{
            return item.name.toLowerCase().indexOf(val.toLowerCase())>-1
          }).map((i)=>{return {merchant_name:i.name,merchant_tag:i.tag}})
          mers.forEach(item => {
            this.merchantOptions.push({value:item.merchant_name,id:item.merchant_tag})
          })
        },100)

      }
      else{
        mers=this.totalBussnies;
        mers.forEach(item => {
          this.merchantOptions.push({value:item.merchant_name,id:item.tag})
        })
      }
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let s = datestring.split(' ')[0]
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(s==today_string)
        return '今天';
      if(s==yest_string)
        return '昨天';
      return this.$moment(new Date(datestring)).format('YYYY-MM-DD')
    },
    async getSources(){
      let res = await api.get(this, {
        path: 'spider.php',
        api: 'get_type_of_list'
      })
      res = res.body
      if (res.status == 'ok') {
        this.sources = res.result
      }
    },
    search(){
      const generateParams=()=>{
        let params={}
        //params.limit=this.form.limit;
        //params.page=this.form.page;
        for(let p in this.form){
          if(p=='status' && this.form.status=='-1'){
            continue;
          }
          else{
            if(this.form[p])
              params[p]=this.form[p]
          }        
        }
        if(this.timeRange.length){
          params.posting_time_from=this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
          params.posting_time_to=this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
            //localStorage.setItem('mailList_timeRange',JSON.stringify(this.timeRange))
        }
        //localStorage.setItem('mailList_theme',this.form.mail_theme)
        return params
      }
      let params=generateParams()
      this.getList(params)
      delete params.page
      delete params.limit
      this.getListCount(params)
    },
    async getList(params) {
        this.loading=true;
        let res = await api.get(this, {
          path: 'spider.php',
          api: 'get_post_list',
          params: params
        })
        this.loading=false;
        res = res.body
        if (res.status == 'ok') {
          this.list = res.result;
        }
    },
    async getListCount(params) {
        let res = await api.get(this, {
          path: 'spider.php',
          api: 'count_post_list',
          params:params
        })
        this.totalCount=+res.body.result;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .article-row{
    display: flex;
    padding: 18px 21px;
    border-bottom: 1px solid #f3f3f9;
  }
  .article-row.email{
    cursor: pointer;
  }
  .article-row:hover{
    background-color: #f3f3f9;
  }
  .title{
    height: 20px;
    font-size: 18px;
    color: #333;
    line-height: 20px;
    text-align: center;
    margin-bottom: 35px;
    font-weight: bold;
  }
  .empty-content {
    padding: 50px 0 50px;
  }
</style>

<style lang="scss">
.order-list {
  margin-bottom: 80px;

  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.table{
  margin-top:43px;
  overflow-x:auto;
  overflow-y:hidden;
  .table-head,
  .table-body{
    display: flex;
  }
  .table-head{
    padding: 18px 11px 18px 21px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
  }
  .table-row-title{
    display: flex;
  }
  .table-head{
    color:#888888;
  }
  .seporater-order{
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top:none;
      line-height: 40px;
    }
  .table-row-content{
    //display:flex;
    padding:25px 50px 30px;
    border: 1px solid #D7D7D7;
    border-top:none;
    &.order{
      display:block;
      border-top: 1px solid #D7D7D7;
    }
  }
  .table-row-seperator{
    float: left;
    height: 33px;
    width: 100%;
    border-left: 1pX dashed #D7D7D7;
    border-right: 1px dashed #D7D7D7;
  }
}
.yd-pagination{
  margin-top:30px;
}
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }
.empty-logo {
  width: 90px;
  margin: 0 auto;
  height: 165px;

  $width: 45px;
  $height: 26px;
  .rhombus-narrow {
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-bottom: $height solid #333333;
    position: relative;
    top: -$width;
  }
  .rhombus-narrow:after {
    content: '';
    position: absolute;
    left: -$width;
    top: $height;
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-top: $height solid #333333;
  }

  .left,
  .right {
    .border {
      position: absolute;
      width: 86px;
      height: 2px;
    }
  }

  .left {
    border-bottom-color: #888;
    &:after {
      border-top-color: #888;
    }
    transform:rotate(60deg);
    top: -55px;
    left: 5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #888;
    }
  }

  .right {
    border-bottom-color: #666666;
    &:after {
      border-top-color: #666666;
    }
    transform:rotate(-60deg);
    top: -126px;
    left: -5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/articles/Crawler.vue